<quill-editor #quillEditorId [(ngModel)]="editorValue" [placeholder]="placeholder" [modules]="modules" (ngModelChange)="onEditorBlur($event)" [maxLength]="maxLength">
</quill-editor>